import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SharedEventService {
	private readonly _event = new BehaviorSubject(undefined);
	private readonly event$ = this._event.asObservable();

	emitEvent() {
		this._event.next(undefined);
	}

	receiveEvent() {
		return this.event$;
	}
}
